// Generated automatically, please don't write here

window._env_ = {
  APICONFIG_TENANT: "https://login.microsoftonline.com/7788edaf-0346-4068-9d79-c868aed15b3d",
  APICONFIG_CLIENT_ID: "46f05e88-753f-472f-88f4-8514ddcce1cb",
  APICONFIG_BASEPATH: "/apiconfig/api/v1",
  APICONFIG_REDIRECT_URI: "https://config.uat.platform.pagopa.it/",
  APICONFIG_SCOPES: "api://pagopa-u-apiconfig-be/access-apiconfig-be",
  APICONFIG_HOST: "https://api.uat.platform.pagopa.it",
  APICONFIG_BASEPATH_ALT: "",
};
